<app-dialog-header
  [dialogRef]="dialogRef"
  [title]="data.title"
  (close)="dialogRef.close()"
/>

<mat-dialog-content>
  <mat-selection-list
    [(ngModel)]="selectedEntities"
    multiple="false"
  >
    @for (option of data.entities; track option.id) {
      <mat-list-option
        [value]="option.id"
        class="label-color"
      >
        {{ option.displayName }}
      </mat-list-option>
    }
  </mat-selection-list>

  <div class="custom-checkbox-row">
    <span class="label-color">Rechnungsadresse ändern</span>

    <mat-checkbox [(ngModel)]="changeAddress"/>
  </div>

  @if (changeAddress) {
    <kpi4me-text-element
      [formControlElement]="this.addressline1"
      label="Adressezeile 1"
      [required]=true
    />

    <kpi4me-text-element
      [formControlElement]="this.addressline2"
      label="Adressezeile 2"
    />

    <kpi4me-text-element
      [formControlElement]="this.addressline3"
      label="Adressezeile 3"
    />

    <kpi4me-text-element
      [formControlElement]="this.street"
      label="Straße und Hausnummer"
    />

    <div class="flex-row" style="gap: 1rem">
      <kpi4me-text-element
        [formControlElement]="this.postcode"
        label="Postleitzahl"
        [required]=true
      />

      <kpi4me-text-element
        [formControlElement]="this.city"
        label="Ort"
        [required]=true
      />
    </div>

    <kpi4me-select-element
      [formControlElement]="this.country"
      [options]="countries"
      label="Land"
      [multiple]=false
      [editEnabled]=false
      [deleteEnabled]=false
    />
  }
</mat-dialog-content>

<mat-dialog-actions>
  <app-confirm-icon-button
    (customClick)="onConfirm()"
    [disabled]="selectedEntities.length <= 0 ||
      (changeAddress && (addressline1.invalid || postcode.invalid || city.invalid || country.invalid))"
  />
</mat-dialog-actions>
